export function repeatCharacter(character: string, numberOfTimes: number): string {
    const repeatNumberOfTimes = numberOfTimes < 0 ? 0 : numberOfTimes;
    return character.repeat(Math.floor(repeatNumberOfTimes));
}
